import React from 'react';
import { useNavigate } from 'react-router-dom';

import { OWNERS_HUB_ROUTES } from '@/constants/routes';
import { useAppDispatch } from '@/store';
import { clearSessionData, ConfigReducer as SessionState, sessionEnsure, SessionStatus } from '@/store/slices/session';

export function useSession(session: SessionState) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    // Configurator entry: resume an existing session, mint only if there is none.
    dispatch(sessionEnsure());
  }, [dispatch]);

  React.useEffect(() => {
    switch (session.status) {
      case SessionStatus.customization:
        navigate(OWNERS_HUB_ROUTES.STUDIO_CONFIGURATOR);
        break;

      case SessionStatus.payment_successful:
        navigate(OWNERS_HUB_ROUTES.CONFIGURATOR_PAYMENT_SUCCESSFUL);
        break;

      case SessionStatus.done:
        dispatch(clearSessionData());
        navigate(OWNERS_HUB_ROUTES.REGISTER);
        break;

      default:
        break;
    }
  }, [dispatch, navigate, session.status]);
}
